import React, { useState } from 'react';
import * as FaIcons from "react-icons/fa";
import * as AiIcons from "react-icons/ai";
import BfwLogo from '../assets/logo-1.png';
import './sidebar.css';
import { IconContext } from 'react-icons';
import { Link } from 'react-router-dom';
import { SidebarData } from './SidebarData';

function Sidebar() {
    const [sidebar, setSidebar] = useState(false);
    const [subnavStates, setSubnavStates] = useState({});

    const showSidebar = () => setSidebar(prev => !prev);

    // Nur ein Subnav gleichzeitig öffnen oder alles schließen
    const toggleSubnav = (index) => {
        setSubnavStates((prevState) => {
            const isOpen = prevState[index];
            return isOpen ? {} : { [index]: true };
        });
    };

    // Klick auf Hauptmenü
    const handleNavClick = (item, index) => {
        if (item.subNav) {
            toggleSubnav(index);
        } else {
            setSidebar(false);
            setSubnavStates({});
        }
    };

    // Klick auf Untermenü
    const handleSubNavClick = () => {
        setSidebar(false);
        setSubnavStates({});
    };

    return (
        <IconContext.Provider value={{ color: '#fff' }}>
            <div className='navbar'>
                <Link to="#" className='menu-bars h'>
                    <FaIcons.FaBars onClick={showSidebar} />
                </Link>
            </div>

            <nav className={sidebar ? 'nav-menu active' : 'nav-menu'}>
                <ul className='nav-menu-items'>
                    <Link to="#" className='menu-bars x'>
                        <AiIcons.AiOutlineClose onClick={showSidebar} />
                    </Link>

                    {SidebarData.map((item, index) => (
                        <React.Fragment key={index}>
                            <li className={item.cName} onClick={() => handleNavClick(item, index)}>
                                <Link to={item.path}>
                                    {item.icon}
                                    <span>{item.title}</span>
                                    {item.subNav && (
                                        <span className='dropdown-icon'>
                                            {subnavStates[index] ? item.iconOpened : item.iconClosed}
                                        </span>
                                    )}
                                </Link>
                            </li>

                            {item.subNav && subnavStates[index] && item.subNav.map((subItem, subIndex) => (
                                <li
                                    key={`${index}-${subIndex}`}
                                    className='nav-sub-item'
                                    onClick={handleSubNavClick}
                                >
                                    <Link to={subItem.path}>
                                        <span>{subItem.title}</span>
                                    </Link>
                                </li>
                            ))}
                        </React.Fragment>
                    ))}

                    <div className="flex-row">
                        <div className="main_links">
                            <p>© 2025 BFW - Bundesforschungszentrum für Wald</p>
                        </div>
                        <div className="flex-2">
                            <a href="https://www.bfw.gv.at/" target="_blank" rel="noreferrer">
                                <img src={BfwLogo} alt="bfw-logo" className="llogo" />
                            </a>
                        </div>
                    </div>
                </ul>
            </nav>
        </IconContext.Provider>
    );
}

export default Sidebar;
